module.exports = __webpack_public_path__ + "img/sliver_logo_bg.427ae779.png";